import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Download } from 'lucide-react';
import { Button } from '../components/ui/button';

const AGB = () => {
  const navigate = useNavigate();

  return (
    <div className="agb-page">
      <div className="agb-container">
        <Button 
          onClick={() => navigate('/')} 
          className="back-button"
          variant="outline"
        >
          <ArrowLeft className="mr-2" />
          Zurück zur Startseite
        </Button>
        
        <h1 className="agb-title">Allgemeine Geschäftsbedingungen (AGB)</h1>
        
        <div className="agb-content">
          <div className="agb-header">
            <p className="agb-company">Sportfreund Cowboy e.U. – Guiding, Bike-Erlebnisse & Drohnen-Erinnerungsvideos</p>
            <p className="agb-details">
              Sportfreund Cowboy e.U. • Inhaber: Mag. Christian Mannert • Wiener Straße 21, 7100 Neusiedl am See<br />
              Firmenbuchnummer: FN 677254 m Landesgericht Eisenstadt • E-Mail: sportfreundcowboy@gmail.com
            </p>
          </div>

          <section className="agb-section">
            <h2>§ 1 Geltungsbereich & Vertragspartner</h2>
            <ol>
              <li>Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Dienstleistungen, geführten Radtouren (E-Bike, Rennrad, Mountainbike, etc.) sowie alle damit verbundenen Nebenleistungen von Sportfreund Cowboy e.U. (im Folgenden „Veranstalter").</li>
              <li>Vertragspartner ist Sportfreund Cowboy e.U., Inhaber Mag. Christian Mannert. Mit der Buchung einer Leistung (sei es online, schriftlich, telefonisch oder über Partner) akzeptiert der Kunde diese Bedingungen vollumfänglich.</li>
              <li>Bei Buchungen über Kooperationspartner (z. B. ÖBB Rail Tours, Hotel- und Eventpartner) gelten für die Vermittlung und Abwicklung des Ticketkaufs vorrangig die Bedingungen des jeweiligen Partners. Für die Durchführung der gebuchten Leistung vor Ort gelten jedoch uneingeschränkt die vorliegenden AGB von Sportfreund Cowboy e.U.</li>
            </ol>
          </section>

          <section className="agb-section">
            <h2>§ 2 Vertragsschluss</h2>
            <ol>
              <li>Die Darstellung des Angebots auf Werbeplattformen oder Webseiten stellt kein rechtlich bindendes Angebot dar. Die Buchung des Kunden (online, per E-Mail oder mündlich) gilt als verbindliches Angebot auf Abschluss eines Dienstleistungsvertrages.</li>
              <li>Der Vertrag kommt erst durch eine ausdrückliche schriftliche Buchungsbestätigung (z. B. per E-Mail) des Veranstalters zustande.</li>
            </ol>
          </section>

          <section className="agb-section">
            <h2>§ 3 Tarife & Umsatzsteuerbefreiung</h2>
            <ol>
              <li>Es gelten die Preise zum Zeitpunkt der Buchung. Alle Tarife verstehen sich als Bruttoraten.</li>
              <li>Der Veranstalter ist Kleinunternehmer gemäß § 6 Abs. 1 Z 27 UStG. Sämtliche Honorare und Preise verstehen sich daher umsatzsteuerbefreit, es wird keine Umsatzsteuer ausgewiesen oder berechnet.</li>
            </ol>
          </section>

          <section className="agb-section">
            <h2>§ 4 Rücktritt & Stornierungsbedingungen</h2>
            <ol>
              <li>
                <strong>Stornierung durch den Kunden:</strong> Ein Rücktritt von der gebuchten Tour muss in schriftlicher Form (per E-Mail) erfolgen. Es gelten folgende Fristen und Stornogebühren:
                <ul>
                  <li>Bis 48 Stunden vor dem vereinbarten Tourstart: Kostenfreie Stornierung möglich.</li>
                  <li>Unter 48 Stunden vor Tourstart oder bei Nichterscheinen („No-Show"): 100% des vertraglich vereinbarten Preises fallen als Stornogebühr an.</li>
                </ul>
              </li>
              <li>
                <strong>Absage durch den Veranstalter (Wetter & Sicherheit):</strong> Da geführte Radtouren im Freien stattfinden, behält sich der Veranstalter das Recht vor, Touren bei unzumutbaren oder gefährlichen Wetterverhältnissen (Starkregen, Hagel, Sturmwarnung, Glätte, Blitzgefahr) im Sinne der Sicherheit der Teilnehmer abzusagen oder zu verschieben. Bei einer Absage durch den Veranstalter vor Beginn der Tour erhält der Kunde bereits geleistete Zahlungen vollständig erstattet oder es wird ein Alternativtermin vereinbart. Weitergehende Schadenersatzansprüche (z. B. für Reisekosten) sind ausgeschlossen.
              </li>
            </ol>
          </section>

          <section className="agb-section">
            <h2>§ 5 Wichtiger Sicherheitshinweis & Eigenverantwortung</h2>
            <p>Die Teilnahme an den Radtouren erfolgt vollständig auf eigene Gefahr, eigenes Risiko und eigene Verantwortung. Jeder Teilnehmer ist verpflichtet, sich verkehrskonform und rücksichtsvoll zu verhalten.</p>
          </section>

          <section className="agb-section">
            <h2>§ 6 Teilnahmevoraussetzungen & Verhaltensregeln</h2>
            <ol>
              <li><strong>Gesundheit & Kondition:</strong> Der Kunde versichert mit seiner Teilnahme, dass er gesundheitlich, körperlich und mental den Anforderungen der gebuchten Aktivität gewachsen ist. Akute Einschränkungen (Herzerkrankungen, Asthma, Gelenkschmerzen, Schwangerschaft, etc.) müssen dem Guide zwingend vor Tourstart unter vier Augen mitgeteilt werden.</li>
              <li><strong>Helmpflicht:</strong> Auf allen geführten Touren gilt ausnahmslos eine strikte Helmpflicht. Die Teilnahme ohne einen geprüften Fahrradhelm ist nicht gestattet und berechtigt den Veranstalter zum sofortigen Ausschluss des Teilnehmers ohne Anspruch auf Erstattung.</li>
              <li><strong>Alkohol- & Drogenverbot:</strong> Vor und während der sportlichen Betätigung gilt ein absolutes Alkohol-, Drogen- und Medikamentenverbot, sofern Letzteres die Fahrtüchtigkeit beeinträchtigt. Bei Zuwiderhandlung erfolgt der sofortige Ausschluss von der Tour.</li>
              <li><strong>Straßenverkehrsordnung (StVO):</strong> Jeder Teilnehmer ist verpflichtet, die österreichischen Verkehrsregeln der StVO strikt zu beachten und den sicherheitsrelevanten Anweisungen des Guides unverzüglich Folge zu leisten.</li>
            </ol>
          </section>

          <section className="agb-section">
            <h2>§ 7 Material & Fahrräder</h2>
            <ol>
              <li>Bei Nutzung eigener Fahrräder oder E-Bikes ist jeder Teilnehmer für den einwandfreien, verkehrssicheren und fahrtüchtigen Zustand seines Sportgeräts selbst verantwortlich.</li>
              <li>Werden Fahrräder oder E-Bikes über einen Hotel- oder Kooperationspartner angemietet bzw. zur Verfügung gestellt, haftet der Teilnehmer für alle von ihm schuldhaft verursachten Beschädigungen an diesen Leihgeräten direkt gegenüber dem jeweiligen Eigentümer/Vermieter.</li>
            </ol>
          </section>

          <section className="agb-section">
            <h2>§ 8 Bild- & Videorechte (Drohnenbegleitung / DSGVO)</h2>
            <p>Ein herausragendes Leistungsmerkmal von Sportfreund Cowboy e.U. ist die visuelle Dokumentation der Tour (z. B. mit Kamera- und Drohnenaufnahmen) zur Erstellung eines persönlichen Erinnerungsvideos.</p>
            <ol>
              <li><strong>Einwilligung:</strong> Der Teilnehmer erteilt mit seiner Buchung und Teilnahme seine ausdrückliche und jederzeit widerrufbare Einwilligung (gemäß Art. 6 Abs. 1 lit. a DSGVO), dass Bild- und Videoaufnahmen (inklusive Luftbildaufnahmen) von ihm während der Tour angefertigt werden.</li>
              <li><strong>Nutzungsrechte des Kunden:</strong> Der Veranstalter stellt das fertige Videomaterial den Teilnehmern zur rein privaten Nutzung zur Verfügung. Eine gewerbliche Verwertung durch den Kunden ist ohne vorherige Absprache untersagt.</li>
              <li><strong>Nutzungsrechte des Veranstalters:</strong> Der Veranstalter ist berechtigt, das Bild- und Videomaterial honorarfrei zu Marketing- und Werbezwecken (z. B. auf der Website www.sportfreund-cowboy.at, auf Social-Media-Kanälen oder in Printmedien) zu veröffentlichen, es sei denn, der Teilnehmer widerspricht dieser Nutzung vor Antritt der Tour ausdrücklich und schriftlich.</li>
              <li><strong>Weitergabe innerhalb der Gruppe:</strong> Der Kunde willigt ein, dass das erstellte Gruppen-Urlaubsvideo auch den anderen Teilnehmern derselben Tour im Rahmen des Service-Angebots zugänglich gemacht wird.</li>
            </ol>
          </section>

          <section className="agb-section">
            <h2>§ 9 Haftungsbeschränkung</h2>
            <ol>
              <li>Die Haftung des Veranstalters für vertragliche oder gesetzliche Pflichtverletzungen wird auf Vorsatz und grobe Fahrlässigkeit beschränkt. Die Haftung für leichte Fahrlässigkeit (mit Ausnahme von Personenschäden) ist ausgeschlossen.</li>
              <li>Für Unfälle, Stürze oder Sachbeschädigungen, die durch eigenes Verschulden des Teilnehmers, Missachtung von Anweisungen oder Nichtbeachtung der StVO entstehen, haftet der Teilnehmer in vollem Umfang selbst.</li>
              <li>Für den Verlust, Diebstahl oder die Beschädigung von persönlichen Gegenständen (z. B. Smartphones, Brillen, Kameras, Kleidung) während der Tour wird keinerlei Haftung übernommen.</li>
            </ol>
          </section>

          <section className="agb-section">
            <h2>§ 10 Datenschutz</h2>
            <p>Die Verarbeitung personenbezogener Daten des Kunden erfolgt unter strenger Einhaltung der Vorgaben der EU-Datenschutz-Grundverordnung (DSGVO) sowie des österreichischen Datenschutzgesetzes (DSG). Informationen zur Datenverarbeitung finden sich in der Datenschutzerklärung auf der Website.</p>
          </section>

          <section className="agb-section">
            <h2>§ 11 Gerichtsstand & anwendbares Recht</h2>
            <ol>
              <li>Es gilt ausschließlich das Recht der Republik Österreich unter Ausschluss von Kollisionsnormen.</li>
              <li>Für alle Streitigkeiten aus oder im Zusammenhang mit diesem Vertragsverhältnis wird als ausschließlicher Gerichtsstand das sachlich zuständige Gericht in Eisenstadt vereinbart, sofern dem keine zwingenden verbraucherschutzrechtlichen Bestimmungen entgegenstehen.</li>
              <li>Sollten einzelne Bestimmungen dieser AGB unwirksam oder undurchführbar sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen davon unberührt.</li>
            </ol>
          </section>

          <div className="agb-download-section">
            <h3>AGB als PDF herunterladen</h3>
            <p>Laden Sie sich die vollständigen AGB als PDF-Dokument herunter:</p>
            <a 
              href="/assets/AGB_Sportfreund_Cowboy.pdf" 
              download="AGB_Sportfreund_Cowboy.pdf"
              className="agb-download-button"
            >
              <Download className="mr-2" />
              AGB herunterladen (PDF)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AGB;
